import React from 'react'
import { Link } from 'gatsby'

import { getUserType } from 'global/context/sub-contexts/userContext'
import { userTypeEnum } from 'services/user'

import PlaceHolderImage from 'components/PlaceholderImage'
import Skeleton from 'components/Skeleton'
import * as queryString from 'query-string'

import './Card.scss'

const Card = ({
  breakId,
  permalink,
  title,
  heroImageUrl,
  featuredImageUrl,
  cardImageUrl,
  step_types,
  sponsored,
  points,
  breakIsCompleted,
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term,
}) => {
  let stepLabel = step_types => {
    if (step_types) {
      if (step_types.length === 1) {
        if (step_types[0] === 'spot difference') {
          return 'spot the difference' //dumb small fix for this truncated name in array
        } else {
          return step_types[0]
        }
      } else if (sponsored !== 'sponsored') {
        return step_types[0]
      } else {
        return `${step_types.length} activities`
      }
    }
  }

  const userType = getUserType()
  let url = ''
  let extraUrlParams = {}

  if (permalink) {
    url = `/break/${permalink}`
  }

  if (sponsored === 'sponsored' && userType !== userTypeEnum.REGISTERED) {
    url = `/exclusive-content/`
    extraUrlParams['id'] = breakId
    extraUrlParams['permalink'] = permalink
  }

  if (utm_source) {
    extraUrlParams['utm_source'] = utm_source
  }

  if (utm_medium) {
    extraUrlParams['utm_medium'] = utm_medium
  }

  if (utm_campaign) {
    extraUrlParams['utm_campaign'] = utm_campaign
  }

  if (utm_term) {
    extraUrlParams['utm_term'] = utm_term
  }

  const extra = queryString.stringify(extraUrlParams)
  if (extra) {
    url = url + '?' + extra
  }

  // there are 3 different images with different aspect ratios
  // we'll likely need a parameter to select the correct one
  let imageUrl = heroImageUrl
  if (featuredImageUrl) {
    imageUrl = featuredImageUrl
  }

  return (
    <Link
      to={url}
      title={title}
      className={`card completed-${breakIsCompleted}`}
      key={permalink}
    >
      <figure className="card__img">
        {breakIsCompleted ? <span className="check"></span> : <></>}
        {imageUrl ? (
          <PlaceHolderImage
            src={imageUrl}
            alt={title}
            width={312}
            height={160}
          />
        ) : (
          <Skeleton width={'100%'} height={160} />
        )}
      </figure>
      <div className="card__details">
        <div className="card__info">
          {!breakIsCompleted && (
            <>
              <div className="card__info-item">{stepLabel(step_types)}</div>
              <div className="card__info-item points">
                <span className="card__info-item__points-int">
                  {!sponsored ? '4' : `${points}`}
                </span>{' '}
                pts
              </div>{' '}
              {/* harcoding 4 point editorial awarding */}
            </>
          )}
          {breakIsCompleted ? (
            <div className="card__info-item completed">
              <strong>Complete</strong>
            </div>
          ) : (
            <></>
          )}
        </div>
        <h2 className="headline">{title || <Skeleton count={2} />}</h2>
        {sponsored === 'sponsored' && (
          <div className="card__info-item">
            <strong>Sponsored content</strong>
          </div>
        )}
      </div>
    </Link>
  )
}

const CardEveryoneCalls = ({
  brk,
  breakIsCompleted,
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term,
}) => {
  // shape of brk data is inconsistent.
  // sometimes we get brk.sponsored (String)
  // sometimes we get brk.isSponsored (boolean)
  let sponsored = brk.sponsored
  if (brk && typeof brk.isSponsored != 'undefined') {
    sponsored = brk.isSponsored === true ? 'sponsored' : 'editorial'
  }

  return (
    <Card
      breakId={brk.id}
      permalink={brk.permalink}
      title={brk.title}
      heroImageUrl={brk.heroImageUrl}
      featuredImageUrl={brk.featuredImageUrl}
      cardImageUrl={brk.cardImageUrl}
      step_types={brk.step_types}
      sponsored={sponsored}
      points={brk.points}
      breakIsCompleted={breakIsCompleted}
      utm_source={utm_source}
      utm_medium={utm_medium}
      utm_campaign={utm_campaign}
      utm_term={utm_term}
    />
  )
}

export default CardEveryoneCalls
